// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip-module_wrapper_a920a","trigger":"Tooltip-module_trigger_9824f","popover":"Tooltip-module_popover_c6c9a"};